module.exports = __webpack_public_path__ + "static/media/forbes.1eb6438d.svg";